/**
 * Puts the org's display units under a page (units slice 2b): every component below reads them with `useShownPrefs`
 * (lib/units/context). Only an org's own choice is given: until the read answers, and for an org that has not chosen,
 * nothing is, so every value shows as stored, as the server serves it (#1190 review MEDIUM 4). A page never waits on
 * the read.
 */
import type { ReactNode } from "react";
import { useDisplayUnits } from "@/lib/api/display-units";
import { DisplayPrefsContext } from "@/lib/units/context";

export function OrgUnits({ children }: { children: ReactNode }) {
  const { shown } = useDisplayUnits();
  return <DisplayPrefsContext.Provider value={shown}>{children}</DisplayPrefsContext.Provider>;
}
